import termsManifest from "../../contracts/terms/manifest.json";

/**
 * The Terms version this bundle publishes: the "Last updated" date of the `legal.terms` it renders, read from
 * the manifest `scripts/renderContractDocuments.mjs` writes. `scripts/contract-documents-sweep.mjs` fails the
 * build when the manifest and the copy disagree, so this cannot name Terms other than the ones on screen.
 */
export const PUBLISHED_TERMS_VERSION: string = termsManifest.version;
